interface ActionButtonProps {
  title: string | JSX.Element;
  icon: JSX.Element;
  testId: string;
  onClick: () => void;
  isEnabled?: boolean;
  isCancelAction?: boolean;
}

export default function ActionButton({
  title,
  icon,
  testId,
  onClick,
  isEnabled = true,
  isCancelAction = false,
}: ActionButtonProps) {
  const classes = `${isEnabled ? "" : "disabled"}${isCancelAction ? " cancel-action" : ""}`;
  return (
    <div onClick={onClick} data-testid={testId} className={`action-popover-button ${classes}`}>
      {icon}
      <span className="action-popover-label">{title}</span>
    </div>
  );
}

ActionButton.defaultProps = {
  isEnabled: true,
  isCancelAction: false,
};
